import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Loader2, Coins } from 'lucide-react';

const inr = (v) => `₹${(v || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

export default function ResellerCommissionsPage() {
  const { api } = useAuth();
  const [d, setD] = useState(null);

  useEffect(() => { api.get('/reseller/commissions').then((r) => setD(r.data)).catch(() => setD(null)); }, [api]);

  if (!d) return <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div>;
  const t = d.totals || {};

  return (
    <div className="space-y-6" data-testid="reseller-commissions-page">
      <div>
        <h1 className="text-2xl font-heading font-bold flex items-center gap-2"><Coins className="w-6 h-6" />Commissions</h1>
        <p className="text-muted-foreground">Your earnings across your merchant network.</p>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-4">
        {[['Gross', t.gross], ['Reversals', t.reversals], ['Paid', t.paid], ['Pending', t.pending], ['Available', t.available]].map(([l, v]) => (
          <Card key={l}><CardContent className="p-4"><p className="text-xs text-muted-foreground mb-1">{l}</p><p className="text-xl font-bold font-mono">{inr(v)}</p></CardContent></Card>
        ))}
      </div>
      <Card><CardContent className="p-0 overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]">
          <thead className="bg-muted/40 text-left text-xs text-muted-foreground">
            <tr><th className="px-4 py-3">Commission</th><th className="px-4 py-3">Order</th><th className="px-4 py-3">Txn Amount</th><th className="px-4 py-3">Merchant Fee</th><th className="px-4 py-3">Your Commission</th><th className="px-4 py-3">Status</th></tr>
          </thead>
          <tbody>
            {d.commissions.length === 0 && <tr><td colSpan={6} className="px-4 py-8 text-center text-muted-foreground">No commissions yet.</td></tr>}
            {d.commissions.map((c) => (
              <tr key={c.id} className="border-t" data-testid={`rc-row-${c.commission_code}`}>
                <td className="px-4 py-3 font-mono">{c.commission_code}</td>
                <td className="px-4 py-3 font-mono">{c.order_id || '—'}</td>
                <td className="px-4 py-3 font-mono">{inr(c.transaction_amount)}</td>
                <td className="px-4 py-3 font-mono">{inr(c.merchant_fee)}</td>
                <td className={`px-4 py-3 font-mono font-semibold ${c.commission_amount < 0 ? 'text-red-500' : 'text-green-600'}`}>{inr(c.commission_amount)}</td>
                <td className="px-4 py-3"><Badge variant={c.status === 'paid' ? 'default' : c.status === 'reversed' ? 'destructive' : 'secondary'}>{c.status}</Badge></td>
              </tr>
            ))}
          </tbody>
        </table>
      </CardContent></Card>
    </div>
  );
}
